import { useParams } from 'react-router';
import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { User } from '../../users/components/User';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejUserDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />} resource='Users' action='update.view'>
          <User userId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejUserDetailPage;
